import React, { useEffect, useRef } from 'react';

const PARTS = [
  { name: 'motor', depth: 'far', speed: 0.32 },
  { name: 'painel', depth: 'far panel', speed: -0.26 },
  { name: 'pneu', depth: 'mid', speed: 0.62 },
  { name: 'banco', depth: 'mid', speed: -0.54 },
  { name: 'sport-banco', depth: 'mid', speed: 0.1 },
  { name: 'cambio', depth: 'front', speed: -0.9 },
  { name: 'sport-cambio', depth: 'front', speed: 0.8 },
];

const clamp = value => Math.min(Math.max(value, 0), 1);
const CarPartsBackground = () => {
  const backdropRef = useRef(null);

  useEffect(() => {
    const backdrop = backdropRef.current;
    const section = backdrop.parentElement;
    const parts = Array.from(
      backdrop.querySelectorAll('[data-parallax-speed]')
    );
    let frameId = null;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = clamp(
        (window.innerHeight - rect.top) / (window.innerHeight + rect.height)
      );
      const travelDistance = Math.min(
        section.offsetHeight * 0.5,
        window.innerHeight * 0.35
      );

      // O blur cresce apenas 5-10%: suficiente para reforçar a profundidade
      // sem descaracterizar as peças automotivas.
      backdrop.style.setProperty(
        '--parts-far-blur',
        `${1.5 + progress * 0.15}px`
      );
      backdrop.style.setProperty(
        '--parts-mid-blur',
        `${1 + progress * 0.075}px`
      );
      backdrop.style.setProperty(
        '--parts-front-blur',
        `${0.5 + progress * 0.025}px`
      );
      parts.forEach(part => {
        const speed = Number(part.dataset.parallaxSpeed);
        const offset = progress * travelDistance * speed;

        part.style.setProperty('--parallax-y', `${offset}px`);
        part.style.setProperty('--parallax-x', `${offset * -0.18}px`);
      });
      frameId = null;
    };

    const requestUpdate = () => {
      if (frameId === null) {
        frameId = window.requestAnimationFrame(updateParallax);
      }
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    requestUpdate();

    return () => {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
    };
  }, []);

  return (
    <div ref={backdropRef} className="car-parts-background" aria-hidden="true">
      {PARTS.map(({ name, depth, speed }) => (
        <video
          key={name}
          className={`car-part car-part--${name} car-part--${depth}`}
          data-parallax-speed={speed}
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
        >
          <source
            src={`/img/car-parts/car-parts-${name}.webm`}
            type="video/webm"
          />
        </video>
      ))}
    </div>
  );
};

export default CarPartsBackground;
